// @flow
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Router } from '@angular/router';

@Component({
    selector: 'generalMenu',
    template: `
    <a *ngFor="let menu of menuData" class="dropdown-item" routerLink="{{menu.RouterLink}}">{{menu.MenuName}}</a>                             
    `
})

export class GeneralMenuComponent implements OnInit {

    menuData;

    static parameters = [HttpClient];

    constructor(private http: HttpClient) {
        this.http = http;
    }

    ngOnInit() {
        this.generalMenu();
    }

    generalMenu(){
        this.http.get('/api/menus/getGeneralMenuLinks/1') 
        .subscribe(response=>{
            this.menuData = response
           // console.log(this.menuData);
        });
    }

    addThing() {
    }

    deleteThing(thing) {

    }

    
}